// ----------------------------
// Created by Bulletproof Games
//            2022
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Cascade reel class
//
// Used to create, spin and animate reels
// Contains no logic.
// Set up reels as follows:
//
//    1 - reelmanager.createReel
//    2 - reelmanager.setSymbol to change initial symbols
//
// To use
//
//    1 - Set data using reelmanager.setData(arrayOfSymbolIndexes)
//    2 - reelmanager.startSpin()
//
//
// No injectors needed for this

infiniReelTemplate.oldCreateReel = infiniReelTemplate.createReel;
infiniReelTemplate.createReel = function () {
  let reel = this.oldCreateReel(...arguments);

  var initialSymbols = [];
  for (var i = 0; i < reel.configParams.totalAppertureSize; ++i) {
    initialSymbols.push({
      symbolId: Math.floor(Math.random() * 6),
    });
  }

  reel.initialise = function (json) {
    reel.symbolContainer = resourceManager.createObject('container', 'symbolContainer', json.FQN, {
      //Move symbols within clip area
      x: (reel.configParams.viewportWidth / 2) * resourceManager.selectedAssetResolution.scaleFactor,
      y: 0,
    });
    reel.symbolContainer.parent.removeChild(reel.symbolContainer);

    reel.interactiveSymbolContainer = new PIXI.Graphics();
    reel.interactiveSymbolContainer.interactive = true;
    reel.interactiveSymbolContainer.mousedown = function (eventData) {
      //Convert the mouse position to be relative to the reel
      var point = eventData.data.getLocalPosition(this);
      //Get the selected index
      var index = Math.floor(point.y / reel.configParams.appertureSpacing);
      index += reel.configParams.preappertureSymbols;

      //Invoke the mousedown event on the selected symbol
      if (reel.symbolSprites[index].symbol.interactive && reel.symbolSprites[index].symbol.mousedown !== undefined)
        reel.symbolSprites[index].symbol.mousedown(eventData);
    };
    reel.interactiveSymbolContainer.beginFill(0x000000, 0);
    reel.interactiveSymbolContainer.drawRect(0, 0, reel.configParams.viewportWidth, reel.configParams.viewportHeight);
    reel.addChild(reel.symbolContainer);

    reel.mask = new PIXI.Graphics();
    reel.mask.beginFill(0x000000, 0);
    reel.mask.drawRect(0, 0, reel.configParams.viewportWidth + 1, reel.configParams.viewportHeight + 1);
    reel.mask.endFill();
    reel.addChild(reel.mask);

    for (var i = 0; i < reel.configParams.totalAppertureSize; i++) {
      var newSymbolContainer = resourceManager.createObject('container', 'symbol' + i, reel.symbolContainer.name, {
        x: 0,
        y: (i + 0.5) * reel.configParams.appertureSpacing,
      });
      newSymbolContainer.index = i;

      if (reel.configParams.useContainer.background) {
        newSymbolContainer.background = resourceManager.createObject(
          'container',
          'backgroundContainer',
          newSymbolContainer.name,
          {
            x: 0,
            y: 0,
          }
        );
      }

      newSymbolContainer.symbol = resourceManager.createObject('movie', 'symbol', newSymbolContainer.name, {
        x: 0,
        y: 0,
        definition: 'staticSymbols',
        cloneTextures: true,
      });

      if (reel.configParams.useContainer.child) {
        newSymbolContainer.symbol.childContainer = resourceManager.createObject(
          'container',
          'childContainer',
          newSymbolContainer.symbol.name,
          {
            x: 0,
            y: 0,
          }
        );
      }
      if (reel.configParams.useContainer.foreground) {
        newSymbolContainer.foreground = resourceManager.createObject(
          'container',
          'foregroundContainer',
          newSymbolContainer.name,
          {
            x: 0,
            y: 0,
          }
        );
      }

      newSymbolContainer.dimReelsCanvas = resourceManager.createObject(
        'graphics',
        'dimReelsCanvas',
        newSymbolContainer.name,
        {
          x: 0,
          y: 0,
        }
      );
      newSymbolContainer.dimReelsCanvas.beginFill(0x000000);
      newSymbolContainer.dimReelsCanvas.drawRect(
        -(reel.configParams.viewportWidth + 1) / 2,
        -(reel.configParams.viewportHeight + 1) / 2,
        reel.configParams.viewportWidth + 1,
        reel.configParams.viewportHeight + 1
      );
      newSymbolContainer.dimReelsCanvas.endFill();
      newSymbolContainer.dimReelsCanvas.alpha = 0.6;
      newSymbolContainer.dimReelsCanvas.visible = false;

      newSymbolContainer.symbol.anchor.set(0.5, 0.5);
      newSymbolContainer.symbol.gotoAndStop(initialSymbols[i].symbolId);

      reel.symbolData.push(initialSymbols[i]);
      reel.symbolSprites.push(newSymbolContainer);
      newSymbolContainer.symbol.symbolIndex = i;
      newSymbolContainer.symbol.parentReel = reel;

      // Confirm all files loaded
      for (var j = 0; j < newSymbolContainer.symbol.textures.length; j++) {
        if (!newSymbolContainer.symbol.textures[j].baseTexture.hasLoaded) {
          console.log(
            'Texture index ' +
              j +
              ' for symbol ' +
              Object.keys(resourceManager.getConfiguration().symbols)[j] +
              ' was not loaded'
          );
          return;
        }
      }

      // Store original UV'. We only do this for the first symbol in the animation movie, as this is the one we spin past.
      if (i === 0) {
        for (var j = 0; j < newSymbolContainer.symbol.textures.length; j++) {
          reel.symbolSize.push({
            width: newSymbolContainer.symbol.textures[j].frame.width,
            height: newSymbolContainer.symbol.textures[j].frame.height,
          });
        }
      }
    }

    for (var i = 0; i < this.symbolData.length; i++) {
      reel.symbolDropDeltas.push(0);
    }

    if (
      reel.configParams.useContainer.background ||
      reel.configParams.useContainer.child ||
      reel.configParams.useContainer.foreground
    ) {
      // A container to use as temporary storage when adjusting the symbols as part of getNextSymbolFromInjector
      reel.workingContainer = resourceManager.createObject('container', 'workingContainer', newSymbolContainer.name, {
        x: 0,
        y: 0,
      });
    }

    // A container to hold all of the animation strips for this reel
    reel.animationStripContainer = resourceManager.createObject('container', 'animationStripContainer', json.FQN, {
      x: 0,
      y: 0,
    });
    reel.animationStripContainer.parent.removeChild(reel.animationStripContainer);
    reel.animationStripContainer.scale.set(1.0, 1.0);

    /*
        reel.animationStripContainer.mask = new PIXI.Graphics();
        reel.animationStripContainer.mask.beginFill(0x000000, 0);
        reel.animationStripContainer.mask.drawRect(-reel.configParams.viewportWidth / 2, 0, reel.configParams.viewportWidth + 1, reel.configParams.viewportHeight + 1);
        reel.animationStripContainer.mask.endFill();
        reel.animationStripContainer.addChild(reel.animationStripContainer.mask);
        */

    // A container to hold all of the animation box strip for this reel
    reel.animationBoxContainer = resourceManager.createObject('container', 'animationBoxContainer', json.FQN, {
      x: 0,
      y: 0,
    });
    reel.animationBoxContainer.parent.removeChild(reel.animationBoxContainer);
  };

  reel.popSymbols = function (symbolsToPop, window, stickyCheck) {
    // Use dropSymbols after calling popSymbls

    // Note it is up to the game programmer to set the symbols that are dropping in before calling this function
    let symbolsTaken = [];
    for (var i = 0; i < this.symbolData.length; i++) {
      this.symbolDropDeltas[i] = 0;
      symbolsTaken[i] = false;
    }

    const indexBecomes = [];

    let foundFiller = false;
    let rowIndex = 0;
    let rowIndex2 = 0;
    let lastFallDistance = 0;
    for (var i = this.symbolDropDeltas.length - 2; i >= 0; i--) {
      rowIndex = i - this.configParams.preappertureSymbols;
      if (rowIndex > 0 && stickyCheck[rowIndex]) continue;
      foundFiller = false;
      for (var j = i; j >= 0; j--) {
        rowIndex2 = j - this.configParams.preappertureSymbols;
        if (rowIndex2 >= 0) {
          if (stickyCheck[rowIndex2] || symbolsToPop[rowIndex2]) continue;
        }
        if (!symbolsTaken[j]) {
          lastFallDistance = i - j;
          this.symbolDropDeltas[i] = lastFallDistance;
          symbolsTaken[j] = true;
          foundFiller = true;
          indexBecomes[rowIndex2] = i;
          break;
        }
      }
      if (!foundFiller) {
        this.symbolDropDeltas[i] = lastFallDistance;
      }
    }

    let checkSymbols = [];
    for (var i = 0; i < this.symbolDropDeltas.length; i++) {
      checkSymbols.push(this.getSymbol(i - this.configParams.preappertureSymbols));
    }

    for (var i = this.symbolDropDeltas.length - 1; i >= 0; --i) {
      var index = i - this.symbolDropDeltas[i];
      if (index < 0) {
        // Get symbol from injector
        // let newSymbol = this.preInjector.getNextSymbol(this.symbolData);
        // this.setReelSymbol(
        //   i - this.configParams.preappertureSymbols,
        //   newSymbol
        // );
      } else if (this.symbolDropDeltas[i] > 0) {
        // Copy from above
        this.setReelSymbol(i - this.configParams.preappertureSymbols, this.symbolData[index]);
        this.symbolSprites[i].position.setY(
          (i + 0.5) * this.configParams.appertureSpacing +
            this.symbolDropDeltas[i] * -this.configParams.appertureSpacing
        );
      }
    }

    return indexBecomes;
  };

  reel.fixSymbolPosition = function (index, pos) {
    if (pos === undefined) pos = index;

    this.symbolSprites[index + this.configParams.preappertureSymbols].position.setY(
      (pos + this.configParams.preappertureSymbols + 0.5) * this.configParams.appertureSpacing
    );
  };

  reel.showSymbolEx = function (index, show) {
    var symbolSpriteIndex = index + this.Props.preappertureSymbols;
    this.symbolSprites[symbolSpriteIndex].visible = show;
  };

  reel.oldDimAllSymbols = reel.dimAllSymbols;
  reel.dimAllSymbols = function (dim, tint) {
    this.oldDimAllSymbols(dim, tint);
  };

  reel.stateMachine.replaceState(
    'JUST_LANDED',
    function () {
      if (this.phase.hold()) {
        if (Reflex.developerModeData.disableReelLandSound === false && this.spinParams.landSound) {
          soundManager.play(this.spinParams.landSound);
        } else spinFunctions.playLandSounds(this.reelIndex);

        this.speedData.currentDecelerationSpeed = this.spinParams.landVelocity;
        this.Props.stateTime = this.spinParams.landAlignTime;

        if (this.spinLandedCallback !== undefined) {
          this.spinLandedCallback(this.reelIndex);
        }

        if (this.spinParams.useBounceAnimation) {
          // Check if any of the symbols in view have a bounce animation
          var symbolTemplate = resourceManager.getConfiguration().symbols;
          for (var i = 0; i < this.configParams.appertureHeight; ++i) {
            var symbolId = this.symbolData[i + this.configParams.preappertureSymbols].symbolId;
            var symbolName = Object.keys(symbolTemplate)[symbolId];
            var template = symbolTemplate[symbolName];

            if (template.bounceTexture !== undefined) {
              // Has a bounce animation, play it
              for (var j = 0; j < this.linkedAnimations.length; ++j) {
                this.linkedAnimations[j].playAnimation(i, template.bounceTexture);
              }
            }
          }
        }

        this.pos = 0.99999 - (this.slamStopRequested ? 0 : this.spinParams.landOffset);
        this.updateSymbols();
        this.stateMachine.switchState(
          this.spinParams.landOffset === 0 || this.slamStopRequested ? 'SPIN_COMPLETE' : 'PULL_BACK'
        );
      }
    }.bind(reel)
  );

  return reel;
};
